export const PLAN_RANK = { free: 0, growth: 1, pro: 2, enterprise: 3 };

export const hasPlan = (plan, required) =>
  (PLAN_RANK[plan] ?? 0) >= (PLAN_RANK[required] ?? 0);

export const PLAN_LABEL = { free: "Free", growth: "Growth", pro: "Pro", enterprise: "Enterprise" };
